<template>
  <div class="page-header clear-filter" filter-color="orange">
    <div class="page-header-image" style="background-image: url('/resource_social22/img/fudan_polyu.png')"></div>
    <div class="content" style="margin-top: 10%">
      <div class="container">
        <div class="row">
          <div class="col-md-5 ml-auto mr-auto">
            <card type="login" plain>
              <fg-input
                  class="no-border input-lg"
                  addon-left-icon="now-ui-icons ui-1_email-85"
                  placeholder="Email..."
                  label="Email"
                  v-model="defaultUser.email"
              >
              </fg-input>

              <fg-input
                  class="no-border input-lg"
                  addon-left-icon="now-ui-icons objects_key-25"
                  placeholder="Password..."
                  label="Password"
                  type="password"
                  v-model="defaultUser.password"
              >
              </fg-input>

              <fg-input
                  class="no-border input-lg"
                  addon-left-icon="now-ui-icons business_bank"
                  placeholder="University/Organization..."
                  label="University/Organization"
                  v-model="defaultUser.uni_org"
              >
              </fg-input>

              <fg-input
                  class="no-border input-lg mb-0"
                  addon-left-icon="now-ui-icons users_circle-08"
                  placeholder="Team Name..."
                  label="Team Name"
                  v-model="defaultUser.team_name"
              >
              </fg-input>
            </card>
          </div>
          <div class="col-md-5 ml-auto mr-auto text-left">
            <card plain>
              <p class="category">Intend To Participate:</p>
              <!--              <p>(multi-choice, can be modified afterwards)</p>-->
              <n-checkbox v-model="checkboxes[i]" v-for="(task, i) in $store.state.tasks" :key="i">{{ i + 1 }}.
                {{ task }}
              </n-checkbox>
            </card>

            <div class="col-md-10">
              <div v-if="isRegisting">
                <a class="btn btn-primary btn-round btn-lg btn-block" disabled>
                  <i class="now-ui-icons animate loader_gear spin" aria-hidden="true"></i>
                </a>
              </div>
<!--              <div class="text-center" v-else disabled>-->
<!--                <a class="btn btn-primary btn-round btn-lg btn-block" @click="regist">Regist Now</a>-->
<!--              </div>-->
              <div class="text-center" v-else disabled>
                <a class="btn btn-primary btn-round btn-lg btn-block">Regist Now</a>
              </div>
            </div>
            <div v-if="isError">
              <div v-for="(msg, i) in errorMessage" :key="i">
                {{ msg }}
              </div>
            </div>
            <div>
              Registration is closed now.
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import {Card, Button, FormGroupInput} from '@/components';
import {Checkbox} from "@/components";
import Message from 'element-ui';

export default {
  name: "indexRegist",
  bodyClass: 'login-page',
  components: {
    Card,
    // MainFooter,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Checkbox.name]: Checkbox,

  },
  data() {
    return {
      // 状态变量
      isRegisting: false,
      // 用户信息
      defaultUser: {
        email: '',
        password: '',
        uni_org: '',
        team_name: '',
        regist_tasks: []
      },
      checkboxes: {0: false, 1: false, 2: false, 3: false, 4: false,},
      // checkboxes: {
      //   unchecked: false,
      //   checked: true,
      //   disabledUnchecked: false,
      //   disabledChecked: true
      // },
      isError: false,
    }
  },
  methods: {

    getCookie(name) {
      var value = '; ' + document.cookie
      var parts = value.split('; ' + name + '=')
      if (parts.length === 2) return parts.pop().split(';').shift()
    },

    regist() {
      // TODO 检查表单是否准确

      // 将 regist_tasks 进行格式转化
      for (let key in this.checkboxes) {
        if (this.checkboxes[key] & (this.defaultUser.regist_tasks.indexOf(key) == -1)) {
          this.defaultUser.regist_tasks.push(key)
        }
      }
      console.log(this.defaultUser)
      // POST 数据
      this.isRegisting = true;
      var userData = JSON.stringify(this.defaultUser);
      var self = this;
      // self.alert = Message;
      this.csrfToken = this.getCookie('csrftoken')
      console.log(this.csrfToken);
      this.$http.post("/apisocial22/regist/", userData, {
        headers: {
          'X-CSRFToken': this.csrfToken,
          'content-type': 'application/json'
        }
      })
          .then(response => {
            var data = response.data;
            console.log(response.data);
            // self.alert.success({message: '<strong>这是 <i>HTML</i> 片段</strong>'})
            if (response.data == "success") {
              this.isError = false;
              this.isRegisting = false;
              // 显示注册成功信息
              this.$http.post("/apisocial22/login/", userData, {
                headers: {
                  'X-CSRFToken': null,
                  'content-type': 'application/json'
                }
              })
                  .then(response => {
                    var data = response.data;
                    console.log(data);
                    // self.alert.success({message: '<strong>这是 <i>HTML</i> 片段</strong>'})
                    if (data.loginStatus == "success") {
                      // 在 localStorage 中添加用户信息 (除非被清除, 否则永久保存, 避免使用)
                      localStorage.clear()
                      localStorage.setItem('is_login', true);
                      localStorage.setItem('token', data.token);
                      localStorage.setItem('loginTime', data.loginTime);
                      localStorage.setItem('email', data.userInfo.email);
                      localStorage.setItem('uni_org', data.userInfo.uni_org);
                      localStorage.setItem('team_name', data.userInfo.team_name);
                      this.$store.commit('addLoginInfo');
                      // 跳转到后台管理界面
                      this.$router.push('/console');
                      // window.location.reload();
                      // this.$router.push('/console')
                    } else {
                      // 显示错误信息
                      this.isError = true;
                      this.errorMessage = response.data.loginStatus;
                      this.isRegisting = false;
                    }
                  })
              // TODO 发送邮件以备份参赛信息
            } else {
              this.isError = true;
              this.errorMessage = [];
              for (let key in response.data) {
                this.errorMessage.push(key + ' ' + response.data[key]);
              }

              // 显示错误信息
            }
            //   // 在localStorage中添加用户信息 (除非被清除, 否则永久保存, 避免使用)
            //   localStorage.clear()
            //   localStorage.setItem('is_login', true);
            //   localStorage.setItem('token', data.token);
            //   localStorage.setItem('loginTime', data.loginTime);
            //   localStorage.setItem('name_zh', data.userInfo.name_zh);
            //   localStorage.setItem('name_en', data.userInfo.name_en);
            //   localStorage.setItem('uid', data.userInfo.uid);
            //   localStorage.setItem('username', data.userInfo.username);
            //   localStorage.setItem('authority', data.userInfo.authority);
            //   localStorage.setItem('portrait_url', data.userInfo.portrait_url);
            //   this.isLogining = false;
            //   this.isSubmitSuccess = true;
            //   this.isShowSnackbar = true;
            //   this.messages = [this.$t('login.success')];
            //   this.timer = setInterval(() => {
            //     // 跳转到选人加分界面
            //     clearInterval(this.timer)
            //     this.timer = null
            //     if (this.from) {
            //       this.$router.push(this.from)
            //     } else {
            //       this.$router.push('/')
            //     }
            //   }, 500)
            // } else {
            //   this.isSubmitSuccess = false;
            //   if (data.loginStatus == "fail") {
            //     this.messages = [this.$t('login.fail')];
            //   } else {
            //     this.messages = [this.$t('login.inexistence')];
            //   }
            // }
            // this.isLogining = false;
            // this.isShowSnackbar = true;
          })

    }
  }
}
</script>

<style scoped>

</style>